import React from 'react';
import ReaderPage from './ReaderPage';

function HomePage() {
  return <ReaderPage />;
}

export default HomePage;
